import {
  Home,
  Ticket,
  AlertTriangle,
  FileText,
  Settings,
  Database,
  BookOpen,
  Users,
  Truck,
  MapPin,
  Package,
  Factory,
  User,
  AlertCircle,
  HelpCircle,
  ArrowUpDown,
  Bug,
  Tags,
  UserCheck,
  Clock,
  Shield,
  BarChart3,
  ClipboardList,
  CheckSquare,
  Layers,
  AppWindow,
  Store,
  CreditCard,
  Sparkles,
  ScanSearch
} from 'lucide-react';

export const menuItems = [
  { id: 'dashboard', label: 'Dashboard', icon: Home },
  { 
    id: 'tickets', 
    label: 'Gestão de Tickets', 
    icon: Ticket,
    children: [
      { id: 'incidents', label: 'Incidentes', icon: AlertCircle },
      { id: 'requests', label: 'Requisições', icon: HelpCircle },
      { id: 'problems', label: 'Problemas', icon: Bug },
      { id: 'changes', label: 'Mudanças', icon: ArrowUpDown }
    ]
  },
  { id: 'knowledge', label: 'Base de Conhecimento', icon: BookOpen },
  { 
    id: 'formularios', 
    label: 'Formulários', 
    icon: ClipboardList,
    children: [
      { id: 'formularios-lista', label: 'Meus Formulários', icon: ClipboardList },
      { id: 'planos-acao', label: 'Planos de Ação', icon: CheckSquare }
    ]
  },
  { id: 'reports', label: 'Relatórios', icon: BarChart3 },
  { 
    id: 'cmdb', 
    label: 'CMDB', 
    icon: Database,
    children: [
      { id: 'ativos', label: 'Ativos', icon: Package },
      { id: 'tipos-ativos', label: 'Tipos de Ativos', icon: Layers },
      { id: 'softwares', label: 'Softwares e Licenças', icon: AppWindow },
      { id: 'contratos', label: 'Contratos', icon: FileText },
      { id: 'fabricantes', label: 'Fabricantes', icon: Factory },
      { id: 'fornecedores', label: 'Fornecedores', icon: Truck },
      { id: 'localizacao', label: 'Localização', icon: MapPin },
      { id: 'acmdb', label: 'ACMDB', icon: ScanSearch }
    ]
  },
  { 
    id: 'contacts', 
    label: 'Contatos', 
    icon: Users,
    children: [
      { id: 'users', label: 'Usuários', icon: User },
      { id: 'groups', label: 'Grupos', icon: Users },
      { id: 'profiles', label: 'Perfis', icon: UserCheck }
    ]
  },
  { 
    id: 'settings', 
    label: 'Configurações', 
    icon: Settings,
    children: [
      { id: 'clients', label: 'Clientes', icon: Users },
      { id: 'categoria', label: 'Categoria', icon: Tags },
      { id: 'sla', label: 'SLA', icon: Clock },
      { id: 'ai-config', label: 'Configuração de IA', icon: Sparkles }
    ]
  },
  { id: 'marketplace', label: 'Marketplace', icon: Store, hiddenForTechnician: true },
  { id: 'my-license', label: 'Minha Licença', icon: CreditCard, hiddenForTechnician: true }
];
